import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/pages/project-detail-page.tsx");
